<template>
<div>
  <div class="mt-3 text-center sm:mt-3 flex justify-between">
    <h3 class="text-2xl leading-6 font-medium text-gray-900 dark:text-gray-100 text-left" id="modal-headline">
      Manage participants
    </h3>
    <div class="sm:grid sm:gap-3 sm:grid-flow-row-dense" :class="isModal ? 'sm:grid-cols-2 ' : 'grid-cols-1'">
      <button type="button" v-if="isModal"
              class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white dark:bg-gray-800 text-base font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
              @click="closeModal" data-e2e="cancel_test">
        Close
      </button>
    </div>
  </div>
  <div>
    <h2 class="text-lg font-bold">
      Group links
    </h2>
    <p>Share the following links according to the role they have in the production</p>
    <table class="w-full mt-2">
    <tr v-for="link in room.role_links" class="border align-middle">
      <td class="font-bold py-2 px-2 uppercase text-blue-500 dark:text-blue-300">{{ link.role }}</td>
      <td class="text-gray-800 dark:text-gray-300 px-2 py-2">
        <span class="select-all" :class="'role_link_' + link.key">
        {{ link.full_url }}
        </span>
        <a :href="link.full_url" target="_blank" class="hover:text-blue-600 ml-2 underline hidden">
          Go
        </a>
      </td>
      <td class="items-center align-middle px-2 py-2 shrink-0 w-24">
        <button class="btn btn-secondary" @click="copyToClipboard($event, '.role_link_' + link.key)">Copy link</button>
      </td>
    </tr>
    </table>
  </div>
  <hr class="my-5">
  <div class="mt-4">
    <div class="flex justify-between">
      <div>
    <h2 class="text-lg font-bold">
      Personal links
    </h2>
    <p>Invite someone by email directly from here</p>
  </div>
        <button type="button" class="btn sm:text-sm" @click="saveParticipants" :class="[isModal ? 'sm:col-start-2' : '', unsavedParticipants.length ? 'btn-primary' : 'btn-disabled']"
                :disabled="!unsavedParticipants.length" data-e2e="save_test">
          Save and Invite {{ unsavedParticipants.length == 0 ? '' : unsavedParticipants.length }}
        </button>
</div>
    <table class="w-full divide-y divide-gray-200">
      <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
        <tr v-for="(p,i) in this.participants" v-if="participants && participants.length > 0">
          <td class="px-2 py-2 whitespace-nowrap">
            <div class="flex items-center">
              <div class="">
                <div class="text-sm font-medium text-gray-900 dark:text-gray-200">
                  {{ p.name !== null && p.name !== "" ? p.name : '-' }}
                </div>
                <div class="text-sm text-gray-500 dark:text-gray-400">
                  {{ p.email }}
                </div>
              </div>
            </div>
          </td>
          <td class="px-2 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
            <select v-model="p.role"
                    class="form-input pr-4" @change.stop="updateParticipant(p)" data-e2e="selector_test">
              <option v-for="(r, i) in roles" :key="'r-'.i" :value="r">{{ r }}</option>
            </select>
          </td>
          <td class="px-2 py-2 whitespace-nowrap text-right text-sm font-medium">
            <a v-show="p.status !== 'not_saved' && !p.invitationSent" @click.prevent="sendInvitation(p)"
               class="hover:text-blue-500 text-gray-800 dark:text-gray-100 cursor-pointer">Send invitation again</a>
            <span v-show="p.status !== 'not_saved' && p.invitationSent">Invitation sent!</span>
          </td>
          <td class="px-2 py-2 whitespace-nowrap text-right text-sm">
            <a v-show="p.status !== 'not_saved' && !p.is_allowed_sharing" @click.prevent="allowSharing(p);p"
               class="hover:text-blue-500 text-gray-800 dark:text-gray-100 cursor-pointer">Allow Sharing</a>
            <div class="text-sm text-gray-500 dark:text-gray-200" v-show="p.status !== 'not_saved' && p.is_allowed_sharing">Sharing
              takes
            </div>
          </td>
          <td class="px-2 py-2 whitespace-nowrap text-right text-sm">
            <a @click.prevent="eliminateParticipant(p)" class="cursor-pointer text-gray-800 dark:text-gray-200 hover:text-red-600"
               data-e2e="remove_btn">Remove</a>
          </td>
        </tr>
        <tr v-if="participants && participants.length == 0">
          <td colspan="5" class="text-center text-gray-600 pt-5">You havent invited anyone personally</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="mt-10" v-if="filteredFavoriteParticipants.length > 0">
    <h3 class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Participants previously added to sessions</h3>
    <ul role="list" class="grid grid-cols-2 gap-2 mt-4 border-t border-b border-gray-200 dark:border-gray-700 divide-y divide-gray-200 dark:divide-gray-800">
      <li class="py-2 pr-2 flex items-center justify-between space-x-2" v-for="p in filteredFavoriteParticipants">
        <div class="min-w-0 flex-1 flex items-center space-x-3">
          <div class="flex-shrink-0">
            <div class="h-5 w-5 rounded-full ring-2 ring-white">
              <img :title="p.name" class="w-full" :src="'https://beta.milan.mictap.com/siglas?label='+ siglasFromName(p.name) +'&bg=0000FF&fg=FFFFFF&size=100'" alt="" />
            </div>
          </div>

          <div class="min-w-0 flex-1">
            <p class="text-sm font-medium text-gray-900 dark:text-gray-200 truncate">
              {{ p.name !== null && p.name !== "" ? p.name : '-' }} <span class="text-gray-500 text-sm"> - {{ p.role }}</span>
            </p>
            <p class="text-sm font-medium text-gray-500 dark:text-gray-400 truncate">{{ p.email }}</p>
          </div>
        </div>
        <div class="flex-shrink-0">
          <button type="button"  @click="addFavoriteParticipant(p)" class="inline-flex items-center py-2 px-3 btn btn-secondary">
            <!-- Heroicon name: solid/plus-sm -->
            <svg class="-ml-1 mr-0.5 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
            </svg>
            <span class="text-sm font-medium"> Add <span class="sr-only">{{ p.name }}</span> </span>
          </button>
        </div>
      </li>
    </ul>
  </div>
  <div class="mt-5 w-full flex items-start">
    <div class="w-4/12 mr-1">
      <div class="relative">
        <input name="name" type="text" placeholder="Name (Recommended)" @change="errorName = null"
               v-model="inputParticipant.name" :class="{
                                                       'block w-full pr-10 border-red-300 text-red-900 placeholder-red-300 focus:outline-none focus:ring-red-500 focus:border-red-500': errorName != null,
                                                       'form-input': errorName == null
                                                       }">
      </div>
      <p v-if="errorName != null" class="mt-1 text-sm text-red-600" id="name-error">{{ errorName }}</p>
    </div>
    <div class="w-4/12 mx-1">
      <div class="relative">
        <input name="email" type="email" placeholder="Email" @change="errorEmail = null"
               v-model="inputParticipant.email" :class="{
                                                        'block w-full pr-10 border-red-300 text-red-900 placeholder-red-300 focus:outline-none focus:ring-red-500 focus:border-red-500': errorEmail != null,
                                                        'form-input': errorEmail == null
                                                        }" class="w-full pr-10 focus:outline-none focus:ring-red-500 focus:border-red-500">
      </div>
      <p v-if="errorEmail != null" class="mt-1 text-sm text-red-600" id="email-error">{{ errorEmail }}</p>
    </div>
    <div class="w-2/12 mx-1">
      <select v-model="inputParticipant.role"
              class="form-input" @change="errorName = null" data-e2e="selector_test">
        <option v-for="(r, i) in roles" :key="'r-'.i" :value="r">{{ r }}</option>
      </select>
      <p v-if="errorRole != null" class="mt-1 text-sm text-red-600" id="email-error">{{ errorRole }}</p>
    </div>
    <div class="w-2/12 mx-1">
      <button type="button" class="btn w-full" @click="this.addParticipantToList"
              :class="{'btn-disabled disabled opacity-50': participants.length >= roomLimit, 'btn-primary': participants.length < roomLimit}"
              data-e2e="add_btn_test">
        Add
      </button>
    </div>
  </div>


  </div>
</template>

<script>
import axios from "axios";
import {localNotify} from 'utils/notifications';

export default {
  name: "manage-participants",
  data(){
    return {
      inputParticipant: {role: 'Guest', status: 'not_saved'},
      errorName: null,
      errorEmail: null,
      errorRole: null,
      roomLimit: 20,
      token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      participants: [],
      favoriteParticipants: [],
    }
  },
  props: {
    method: { type: Function },
    roles: {
      type: Array
    },
    isModal: {
      type: Boolean,
      required: false,
      default: true
    },
    isInTrial: {
      type: Boolean,
      required: false,
      default: false
    },
    room: {
      type: Object,
      required: true,
      validator: function (value) {
        return value.name // check if it has an id
      }
    },
  },
  computed: {
    filteredFavoriteParticipants(){
      return this.favoriteParticipants.filter(p => !this.participants.some((pa) => pa.email == p.email ))
    },
    unsavedParticipants() {
      return this.participants.filter(p => p.status == 'not_saved');
    }
  },
  mounted() {
    this.loadFavoriteParticipants();
    this.loadParticipants();
  },
  methods: {
    addFavoriteParticipant(participant){
      this.inputParticipant = participant;
      if (!this.roles.includes(participant.role)) participant.role = this.roles[0];
      this.inputParticipant.role = participant.role;
      this.inputParticipant.status = 'not_saved'
      this.addParticipantToList();
    },
    addParticipantToList: function (e) {
      if(e) e.preventDefault();
      if (this.participants.find(({email}) => email === this.inputParticipant.email) !== undefined) {
        this.errorEmail = 'Email already added';
      }
      if (this.isInTrial) {
        if (this.countByRole('Guest') + this.countByRole('Production') > 3) {
          this.errorName = 'You can have up to 3 Guests and Production members in trial mode';
        }
      }
      if (this.participants.length === this.roomLimit) {
        // show message
        return
      }
      if (!this.inputParticipant.email) {
        this.errorEmail = "Email required";
      } else if (!this.validEmail(this.inputParticipant.email)) {
        this.errorEmail = "Email is not valid";
      }

      if (this.errorEmail != null || this.errorName != null) {
        return
      }
      // @Presenter
      if(this.room.product.display_name === 'Presenter'){
        if(this.countByRole('Presenter') >= 2 && this.inputParticipant.role == 'Presenter'){
          this.errorRole = "There can only be 2 presenters per session"
          return
        }
      }
      //this.inputParticipant.role = "Guest";
      this.inputParticipant.allow_sharing = false;
      this.participants.push(this.inputParticipant);
      this.inputParticipant = {role: 'Guest', status: 'not_saved'};
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    siglasFromName(name){
      if (!name) return ""
      return name.trim().split(" ").map(a => a[0].toUpperCase()).join("").slice(0,2)
    },
    saveParticipants: function (e) {
      axios.post('/rooms/' + this.room.id + '/participants', {
            participants: this.participants,
            authenticity_token: this.token
          },
          {headers: {'Content-Type': 'application/json'}}).then(response => {
        if (response.status === 200) {
          this.closeModal();
          this.loadParticipants()
          this.requestLoadParticipants();
        }
      }).catch(err => {
        localNotify(err, 'error')
      })
    },
    sendInvitation: function (participant) {
      let url = '/rooms/' + this.room.id + '/send_invite'
      let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
      let data = {
        email: participant.email,
        authenticity_token: this.token
      };
      axios.post(url, data, {headers}).then(response => {
        if (response.status === 200) {
          participant.invitationSent = true;
          // HACK: to make the list refresh itself
          participant.name = participant.name + " ";
        }
      }).catch(err => {
        console.log(err);
      })
    },
    eliminateParticipant: function (participant) {
      let url = `/rooms/${this.room.id}/participants?email=${participant.email}`
      let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
      let data = {authenticity_token: this.token};

      axios.delete(url, {headers, data})
          .then(response => {
            if (response.status === 200 || response.data.message === 'Participant not found') {
              let index;
              for (let i = 0; i < this.participants.length; i++) {
                if (this.participants[i].email === participant.email) {
                  index = i;
                  break;
                }
              }
              this.participants.splice(index, 1);
            }
          }).catch(err => {
        console.log(err);
      });
    },
    updateParticipant(participant) {
      if (participant.status === "not_saved") return;
      let url = `/rooms/${this.room.id}/participants?email=${participant.email}`
      let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
      let data = participant;
      data['authenticity_token'] = this.token;

      axios.put(url, data, {headers})
          .then(response => {
            if (response.status == '200') {
              localNotify(response.data.message, 'success')
            } else {
              localNotify(response.data.message, 'error')
            }
          })

    },
    countByRole: function (role) {
      var count = 0;
      this.participants.forEach(x => {
        if (x.role === role)
          count++;
      });
      return count;
    },
    allowSharing(participant) {
      var r = confirm("Are you sure to Allow Sharing to " + participant.name + "?");
      if (r === false) {
        return
      }
      let url = `/room/${this.room.id}/shared_videos`;
      let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
      let data = participant;
      data['authenticity_token'] = this.token;

      const self = this;
      axios.post(url, data, {headers}).then(response => {
        // self.getParticipant(participant).is_allowed_sharing = true; // set the participants value, this could be replaced with a loadParticipants method
        // self.getParticipant(participant).name = self.getParticipant(participant).name + " "; // hack to make UI update
        if (response.status == '200') {
          this.requestLoadParticipants();
          this.loadParticipants();
          localNotify(response.data.message, 'success')
        } else {
          localNotify(response.data.message, 'error')
        }
      }).catch(error => {
        console.error(error);
        localNotify(error.response.data.message, 'error')
      });
    },
    closeModal(){
      this.$emit('close-modal')
    },
    requestLoadParticipants(){
      this.$emit('on-request-load-participants')
    },
    loadParticipants: function () {
      axios.get('/rooms/' + this.room.id + '/participants').then(response => {
        this.participants = response.data;
        this.participants.forEach(p => {
          p.invitationSent = false;
          p.is_allowed_sharing = p.allow_sharing_until != null && Date.parse(p.allow_sharing_until) > Date.now();
        });
      }).catch(err => {
        console.log(err);
      })
    },
    loadFavoriteParticipants: function () {
      axios.get('/participants/favorite').then(response => {
        this.favoriteParticipants = response.data;
        this.favoriteParticipants.forEach(p => {
          p.invitationSent = false;
          p.is_allowed_sharing = false;
        });
      }).catch(err => {
        console.log(err);
      })
    },
    copyToClipboard(evt, selector){
      let el = document.querySelector(selector);
      if (el){
        let tempInput = document.createElement("input");
        tempInput.value = el.innerText;
        document.body.appendChild(tempInput);
        tempInput.select();
        tempInput.setSelectionRange(0, 99999); /*For mobile devices*/
        document.execCommand("copy");
        tempInput.remove();

        // change temporarily the text of the button to "copied"
        evt.target.innerText = "Copied!"
        evt.target.disabled = true
        evt.target.classList.remove('btn-secondary')
        setTimeout(() => {
          evt.target.innerText = "Copy link"
          evt.target.disabled = false
          evt.target.classList.add('btn-secondary')
        }, 2000)
      }
    }
  }
}
</script>

<style scoped>

</style>
